module.exports = __webpack_public_path__ + "img/xx@2x.0ada315e.png";